import React from 'react';
import { MotifDropdownItem } from '@ey-xd/motif-react';

type DropDownItemProps = {
    action: string;
    children?: React.ReactNode;
    disabled?: boolean;
    onClickHandler: (action: string) => void;
};

const DropdownItem = ({ action, onClickHandler, children, ...other }: DropDownItemProps) => {
    return (
        <MotifDropdownItem onClick={() => onClickHandler(action)} {...other}>
            {children}
        </MotifDropdownItem>
    );
};

export default DropdownItem;
